import * as Cesium from 'cesium';
export const STORAGE_KEY = 'landscope_unsaved_measurements';
const isStoredCircle = (s) => s.kind === 'circle';
const normalizeStored = (raw) => {
    if (!raw || typeof raw !== 'object')
        return null;
    const obj = raw;
    // Pre-union format had no `kind`; treat as line for backwards compatibility.
    if (obj.kind === 'circle')
        return obj;
    if (obj.kind === 'line' || obj.kind === undefined) {
        return { ...obj, kind: 'line' };
    }
    return null;
};
export const serializeMeasurementsForStorage = (measurements, projectId, existingJson) => {
    let existingItems = [];
    if (existingJson) {
        try {
            const parsed = JSON.parse(existingJson);
            existingItems = parsed.map(normalizeStored).filter((s) => s !== null);
        }
        catch ( /* ignore */_a) { /* ignore */ }
    }
    const otherProjectItems = existingItems.filter(item => item.projectId !== projectId);
    const currentProjectItems = [];
    for (const m of measurements) {
        if (m.kind === 'line') {
            const startCart = Cesium.Cartographic.fromCartesian(m.startPoint);
            const endCart = Cesium.Cartographic.fromCartesian(m.endPoint);
            currentProjectItems.push({
                kind: 'line',
                id: m.id,
                name: m.name,
                startLat: Cesium.Math.toDegrees(startCart.latitude),
                startLng: Cesium.Math.toDegrees(startCart.longitude),
                endLat: Cesium.Math.toDegrees(endCart.latitude),
                endLng: Cesium.Math.toDegrees(endCart.longitude),
                color: m.color,
                displayUnit: m.displayUnit,
                projectId: m.projectId,
                lineWidth: m.lineWidth,
                colorBy: m.colorBy,
                showLabel: m.showLabel,
            });
        }
        else {
            const centerCart = Cesium.Cartographic.fromCartesian(m.center);
            currentProjectItems.push({
                kind: 'circle',
                id: m.id,
                name: m.name,
                centerLat: Cesium.Math.toDegrees(centerCart.latitude),
                centerLng: Cesium.Math.toDegrees(centerCart.longitude),
                radiusMeters: m.radiusMeters,
                color: m.color,
                outlineColor: m.outlineColor,
                fillOpacity: m.fillOpacity,
                displayUnit: m.displayUnit,
                areaUnit: m.areaUnit,
                projectId: m.projectId,
                lineWidth: m.lineWidth,
                showLabel: m.showLabel,
            });
        }
    }
    return [...otherProjectItems, ...currentProjectItems];
};
export const deserializeStoredMeasurements = (stored, projectId) => {
    return stored
        .filter(s => s.projectId === projectId)
        .map((s) => {
        if (isStoredCircle(s)) {
            return {
                kind: 'circle',
                id: s.id,
                name: s.name,
                centerLat: s.centerLat,
                centerLng: s.centerLng,
                radiusMeters: s.radiusMeters,
                color: s.color,
                outlineColor: s.outlineColor,
                fillOpacity: s.fillOpacity,
                unit: s.displayUnit,
                areaUnit: s.areaUnit,
                projectId: s.projectId,
                lineWidth: s.lineWidth,
                showLabel: s.showLabel,
            };
        }
        return {
            kind: 'line',
            id: s.id,
            name: s.name,
            startLat: s.startLat,
            startLng: s.startLng,
            endLat: s.endLat,
            endLng: s.endLng,
            color: s.color,
            unit: s.displayUnit,
            projectId: s.projectId,
            lineWidth: s.lineWidth,
            colorBy: s.colorBy,
            showLabel: s.showLabel,
        };
    });
};
